// Read a picked File's bytes ONCE into a stable, in-memory File.
//
// A File chosen from an <input type="file"> is otherwise read multiple times
// (IndexedDB stash + background R2 upload + text extraction) while the input is
// reset (`e.target.value = ""`) synchronously right after onChange. Re-reading a
// File after its input is cleared intermittently yields an EMPTY read — which
// surfaced as a "empty file" 422 from /lecture/source-pdf and a failed marking
// start ("sometimes the PDF wouldn't upload/start").
//
// Calling `arrayBuffer()` first — during the synchronous part of the pick
// handler, before the input reset runs — captures the bytes reliably; every
// downstream consumer then reads the in-memory copy instead of the original.
export async function snapshotFile(f: File): Promise<File> {
  const buf = await f.arrayBuffer();
  if (buf.byteLength === 0) {
    throw new Error("That file appears to be empty — try selecting it again.");
  }
  return new File([buf], f.name, { type: f.type || "application/octet-stream" });
}
